/* eslint-disable react-hooks/exhaustive-deps */
import axiosInstance from "axiosConfig";
import { useState, useEffect, useRef } from "react";
import "./working-time.scss";
import { SVG, ContextMenu, Select, Input } from "components";
import { SVG_TYPE } from "enums";
import { Field, Formik } from "formik";
import { WorkingTimeForm, DeleteWorkingTime } from "features/orders";
import {
  usePostActivityTimeStart,
  usePutActivityTimeStop,
  useUpdateActivityTime,
} from "hooks/activity-time";
import { useSearchParams } from "react-router-dom";
import { useGetMe } from "hooks/auth";
import { convertTime, isMobile } from "utils";
import { debounce } from "lodash";
import { usePWA } from "hooks/usePWA";
import {
  saveActivityTimerSession,
  getActivityTimerSession,
  getNowFormatted,
} from "hooks/useOfflineActivityTimer";
import { toast } from "react-toastify";

interface WorkingTimeType {
  isActive?: boolean;
  timeManagement?: any;
  allTime?: any;
  label?: string;
  activity: any;
}

const WorkingTime = ({
  isActive = false,
  label,
  timeManagement,
  activity,
  allTime,
}: WorkingTimeType) => {
  const isManyActivity = activity.numberOfActivities === "many";
  const isActiveTime = activity && activity.countingTime;

  const activeTime =
    activity && activity.numberOfActivities === "one"
      ? activity.timeManagement &&
        activity.timeManagement.length > 0 &&
        activity.timeManagement.find((item: any) => item.countingTime)
      : activity.activityLabel &&
        activity.activityLabel.length > 0 &&
        activity.activityLabel.find((item: any) => item.allTime);
  const [searchParams] = useSearchParams();
  const orderUuid = searchParams.get("orderUuid");
  const [isWorkingStart, setIsWorkingStart] = useState(isActiveTime);
  const [selectObject, setSelectObject] = useState<any>();
  const [modalManage, setModalManage] = useState({
    type: "",
    data: {},
  });
  const [localTimeManagement, setLocalTimeManagement] = useState<any | null>(
    null
  );
  const [localUserSymbols, setLocalUserSymbols] = useState<string | null>(
    (activity && activity.userSymbols) || null
  );
  const [liveCountedTime, setLiveCountedTime] = useState<string>("");
  const inputRef = useRef(null);
  const timerIntervalRef = useRef<number | null>(null);

  const manyOptions = () => {
    let options: any = [];
    activity?.activityLabel?.forEach((item: any) => {
      options.push({ value: item.activityName, label: item.activityName });
    });
    return options;
  };

  useEffect(() => {
    if (activity?.userSymbols && !localUserSymbols) {
      setLocalUserSymbols(activity.userSymbols);
    }
  }, [activity?.userSymbols, localUserSymbols]);

  useEffect(() => {
    !selectObject &&
      setSelectObject(
        activeTime?.activityName
          ? manyOptions().find(
              (item: any) => item.value === activeTime?.activityName
            )
          : manyOptions()[0]
      );
  }, [manyOptions]);

  const formatDateTime = (dateTime: string) => {
    const [date, time] = dateTime.split(" ");
    const [hours, minutes] = time.split(":");
    return `${date}, ${hours}:${minutes}`;
  };

  const calculateLiveTime = (dateStart: string): string => {
    try {
      const [datePart, timePart] = dateStart.split(" ");
      const [day, month, year] = datePart.split("/").map(Number);
      const [hours, minutes, seconds] = timePart.split(":").map(Number);

      const startDate = new Date(
        year,
        month - 1,
        day,
        hours,
        minutes,
        seconds || 0
      );
      const now = new Date();
      const diffMs = now.getTime() - startDate.getTime();

      if (diffMs < 0) return "0:00";

      const totalMinutes = Math.floor(diffMs / 60000);
      const h = Math.floor(totalMinutes / 60);
      const m = totalMinutes % 60;

      return `${h}:${m.toString().padStart(2, "0")}`;
    } catch (error) {
      console.error("❌ Error calculating live time:", error);
      return "0:00";
    }
  };

  useEffect(() => {
    if (localTimeManagement && localTimeManagement.countingTime) {
      return;
    }
    setIsWorkingStart(isActiveTime);
  }, [isActiveTime, allTime, localTimeManagement]);

  useEffect(() => {
    const currentTimeManagement = isManyActivity
      ? activeTime?.timeManagement
      : activity.timeManagement;

    const openEntry = localTimeManagement?.countingTime
      ? localTimeManagement
      : currentTimeManagement?.find((item: any) => item.countingTime);

    if (openEntry && openEntry.countingTime && openEntry.dateStart) {
      setLiveCountedTime(calculateLiveTime(openEntry.dateStart));

      timerIntervalRef.current = window.setInterval(() => {
        const newTime = calculateLiveTime(openEntry.dateStart);
        setLiveCountedTime(newTime);
      }, 60000);

      return () => {
        if (timerIntervalRef.current) {
          clearInterval(timerIntervalRef.current);
          timerIntervalRef.current = null;
        }
      };
    } else {
      // Jeśli nie ma aktywnego wpisu, wyczyść licznik
      setLiveCountedTime("");
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
        timerIntervalRef.current = null;
      }
    }
  }, [
    localTimeManagement,
    activity.timeManagement,
    activity.countingTime,
    isManyActivity,
    activeTime,
  ]);

  const { mutate: startActivityTime } = usePostActivityTimeStart({
    onSuccess: (data) => {
      setIsWorkingStart(true);
      setLocalTimeManagement(null);
    },
  });

  const { mutate: updateActivityTime } = useUpdateActivityTime();

  const { data: authorizedUser } = useGetMe();
  const { mutate: stopActivityTime } = usePutActivityTimeStop({
    onSuccess: () => {
      setIsWorkingStart(false);
      setLocalTimeManagement(null);
    },
  });
  const { isOffline } = usePWA();

  const isAddWorkingTime = modalManage.type === "addWorkingTime";
  const isDeleteWorkingTime = modalManage.type === "deleteWorkingTime";
  const clearModalManage = () => {
    setModalManage({ type: "", data: modalManage.data });
  };
  const setDeleteWorkingTime = (data: any) => {
    setModalManage({ type: "deleteWorkingTime", data });
  };
  const setAddWorkingTime = (data: any) => {
    setModalManage({ type: "addWorkingTime", data });
  };
  const setEditWorkingTime = (data: any) => {
    setModalManage({ type: "addWorkingTime", data });
  };

  const workingTimeMenu = (label: any, uuid: string, item: any) => {
    return [
      {
        name: "Edytuj",
        disabled: item.countingTime,
        action: () => {
          setEditWorkingTime({
            name: isActive ? selectObject.label : label,
            type: "edit",
            uuid,
            item,
          });
        },
      },
      {
        name: "Usuń",
        disabled: item.countingTime,
        action: () => {
          setDeleteWorkingTime({ name: label, type: "delete", uuid, item });
        },
      },
    ];
  };

  const handleTrigerTime = async () => {
    if (!isWorkingStart) {
      if (isOffline) {
        try {
          const session = getActivityTimerSession();
          const currentActivityUuid = timeManagement?.uuid;

          if (
            session &&
            session.activityUuid &&
            currentActivityUuid &&
            session.activityUuid !== currentActivityUuid
          ) {
            toast.info(
              "Masz już uruchomione zliczanie czasu w innym zadaniu. Zakończ je, aby rozpocząć nowe."
            );
            return;
          }
        } catch {
          //
        }

        if (!orderUuid || !timeManagement?.uuid) {
          return;
        }

        const dateStart = getNowFormatted();
        const tempUuid = `offline-time-open-${Date.now()}`;

        let currentUserSymbols = activity.userSymbols || localUserSymbols || "";

        if (!currentUserSymbols && authorizedUser) {
          const firstName = (authorizedUser as any).firstName || "";
          const lastName = (authorizedUser as any).lastName || "";
          currentUserSymbols = `${firstName.charAt(0)}${lastName.charAt(
            0
          )}`.toUpperCase();
          setLocalUserSymbols(currentUserSymbols);
        }

        saveActivityTimerSession({
          orderUuid,
          activityUuid: timeManagement.uuid,
          timeManagementUuid: undefined,
          dateStart,
          activityName: selectObject ? selectObject.value : null,
          comment: null,
          startedOnline: false,
          userSymbols: currentUserSymbols,
        });

        const openEntry = {
          uuid: tempUuid,
          dateStart,
          dateEnd: null,
          countingTime: true,
          countedTime: "",
          comment: null,
          activityName: selectObject ? selectObject.value : null,
          firstDate: dateStart,
          userSymbols: currentUserSymbols,
        };

        setLocalTimeManagement(openEntry);

        const baseUrl = (axiosInstance.defaults.baseURL || "").replace(
          /\/+$/,
          ""
        );
        const apiUrl = `${baseUrl}/activity/time-management?orderUuid=${orderUuid}`;

        try {
          if (
            "serviceWorker" in navigator &&
            navigator.serviceWorker.controller
          ) {
            navigator.serviceWorker.controller.postMessage({
              type: "OPEN_ACTIVITY_TIME_MANAGEMENT",
              orderUuid,
              activityUuid: timeManagement.uuid,
              activityName: openEntry.activityName,
              timeManagement: openEntry,
              apiUrl,
            });
          } else {
          }
        } catch (error) {
          console.error(
            "❌ [WorkingTime] Error sending OPEN_ACTIVITY_TIME_MANAGEMENT message to SW:",
            error
          );
        }

        try {
          const cacheRaw = localStorage.getItem("offlineApiCache");
          if (cacheRaw && orderUuid) {
            const cache = JSON.parse(cacheRaw) as Record<
              string,
              { data: any; timestamp: number; url: string }
            >;
            const cacheKey = `activity/time-management?orderUuid=${orderUuid}`;
            const entry = cache[cacheKey];

            if (
              entry &&
              entry.data &&
              Array.isArray(entry.data.activityMeasurementLabel)
            ) {
              const list = entry.data.activityMeasurementLabel;

              const target = list.find((a: any) => {
                if (timeManagement?.uuid && a.uuid === timeManagement.uuid)
                  return true;
                if (selectObject?.value && a.activities === selectObject.value)
                  return true;
                return false;
              });

              if (target) {
                if (!target.userSymbols && currentUserSymbols) {
                  target.userSymbols = currentUserSymbols;
                }

                const existing = Array.isArray(target.timeManagement)
                  ? target.timeManagement
                  : [];

                const alreadyExists = existing.some(
                  (item: any) => item.uuid === openEntry.uuid
                );

                if (!alreadyExists) {
                  target.timeManagement = [openEntry, ...existing];
                }

                target.countingTime = true;

                cache[cacheKey] = {
                  ...entry,
                  data: {
                    ...entry.data,
                    activityMeasurementLabel: list,
                  },
                  timestamp: Date.now(),
                };

                localStorage.setItem("offlineApiCache", JSON.stringify(cache));
              }
            }
          }
        } catch (error) {
          console.error(
            "❌ Error updating offlineApiCache with open timeManagement entry (offline start):",
            error
          );
        }

        setIsWorkingStart(true);
        return;
      }

      await startActivityTime({
        orderUuid,
        activityUuid: timeManagement?.uuid,
        activityName: selectObject ? selectObject.value : "",
      });
      return;
    }

    await stopActivityTime({
      timeManagementUuid: isManyActivity
        ? activeTime.timeManagement.find((item: any) => item.countingTime).uuid
        : activeTime.uuid,
    });
  };
  const handleWriteComment = debounce((e: any, timeManagementUuid: string) => {
    const comment = e.target.value;

    if (isOffline) {
      setLocalTimeManagement((prev: any | null) => {
        if (!prev || prev.uuid !== timeManagementUuid) return prev;
        return { ...prev, comment };
      });

      try {
        if (orderUuid) {
          const cacheRaw = localStorage.getItem("offlineApiCache");
          if (cacheRaw) {
            const cache = JSON.parse(cacheRaw) as Record<
              string,
              { data: any; timestamp: number; url: string }
            >;
            const cacheKey = `/activity/time-management?orderUuid=${orderUuid}`;
            const entry = cache[cacheKey];

            if (
              entry &&
              entry.data &&
              Array.isArray(entry.data.activityMeasurementLabel)
            ) {
              const list = entry.data.activityMeasurementLabel;

              list.forEach((a: any) => {
                if (Array.isArray(a.timeManagement)) {
                  a.timeManagement = a.timeManagement.map((t: any) =>
                    t.uuid === timeManagementUuid ? { ...t, comment } : t
                  );
                }
              });

              cache[cacheKey] = {
                ...entry,
                data: {
                  ...entry.data,
                  activityMeasurementLabel: list,
                },
                timestamp: Date.now(),
              };

              localStorage.setItem("offlineApiCache", JSON.stringify(cache));
            }
          }
        }
      } catch (error) {
        console.error(
          "❌ Error updating offlineApiCache comment for open timeManagement entry:",
          error
        );
      }

      try {
        const session = getActivityTimerSession();
        if (session) {
          const updated = { ...session, comment };
          saveActivityTimerSession(updated);
        }
      } catch (error) {
        console.error(
          "❌ Error updating comment in offlineActivityTimer session:",
          error
        );
      }

      return;
    }

    updateActivityTime({ comment, timeManagementUuid });
  }, 1000);

  const handleCommentKeyDown = (e: any) => {
    if (e.key === "Enter") {
      (e.target as HTMLInputElement).blur();
    }
  };

  const activityTimeManagement = isManyActivity
    ? activeTime &&
      activeTime.timeManagement &&
      activeTime.timeManagement.length > 0 &&
      activeTime.timeManagement
    : activity &&
      activity.timeManagement &&
      activity.timeManagement.length > 0 &&
      activity.timeManagement;

  const mergedTimeManagement = () => {
    const base = activityTimeManagement || [];

    if (!localTimeManagement) {
      return base;
    }

    const exists = base.some(
      (item: any) => item.uuid === localTimeManagement.uuid
    );
    if (exists) {
      return base;
    }

    return [localTimeManagement, ...base];
  };

  return (
    <>
      <WorkingTimeForm
        isOpen={isAddWorkingTime}
        data={modalManage.data}
        onClose={() => clearModalManage()}
      />
      <DeleteWorkingTime
        data={modalManage.data}
        isOpen={isDeleteWorkingTime}
        onClose={() => clearModalManage()}
      />
      <div className="working-time">
        <div
          className={`working-time-item ${
            activity.countingTime ? "working-time-item--active" : ""
          }`}
        >
          <div className="working-time-item__content">
            <div className="working-time-item__left">
              <Formik
                initialValues={{
                  type: isManyActivity ? manyOptions()[0].value : "",
                  comment: "",
                }}
                enableReinitialize
                onSubmit={async (values: any) => console.log(values)}
              >
                {({ handleSubmit }) => {
                  return (
                    <form className="working-time-form" onSubmit={handleSubmit}>
                      {isManyActivity && !activeTime?.allTime ? (
                        <>
                          <Field
                            name="type"
                            required
                            onChange={(value: any) => setSelectObject(value)}
                            component={Select}
                            options={manyOptions()}
                          />
                        </>
                      ) : (
                        <div className="working-time-item__name">
                          {isManyActivity ? selectObject?.value : label}
                        </div>
                      )}
                    </form>
                  );
                }}
              </Formik>
            </div>
            <div className="working-time-item__right">
              <div className="working-time-item__start">Razem:</div>
              <div className="working-time-item__timing">
                {isWorkingStart ? (
                  <div className="working-time-item__timing-with-clock">
                    <SVG type={SVG_TYPE.CLOCK} />
                    {liveCountedTime
                      ? convertTime(liveCountedTime)
                      : isManyActivity
                      ? convertTime(activeTime?.allTime)
                      : activity.allTime && convertTime(activity.allTime)}
                  </div>
                ) : activity.allTime ? (
                  convertTime(activity.allTime)
                ) : activeTime && activeTime.allTime ? (
                  convertTime(activeTime.allTime)
                ) : (
                  "0m"
                )}
              </div>
              <div className="working-time-item__buttons">
                <div
                  className="working-time-item__button"
                  onClick={() => handleTrigerTime()}
                >
                  {isWorkingStart ? (
                    <SVG type={SVG_TYPE.STOP} />
                  ) : (
                    <SVG type={SVG_TYPE.PLAY} />
                  )}
                </div>
                {!isOffline && (
                  <div
                    className="working-time-item__button"
                    onClick={() =>
                      setAddWorkingTime({
                        name: isActive
                          ? selectObject
                            ? selectObject.label
                            : ""
                          : label,
                        uuid: "",
                        type: "add",
                        orderUuid,
                        activityUuid: activity.uuid,
                        selectObject,
                        activityName: selectObject?.value,
                      })
                    }
                  >
                    <SVG type={SVG_TYPE.PLUS} />
                  </div>
                )}
              </div>
            </div>
          </div>

          {(activity.userSymbols || localUserSymbols) && (
            <div
              className="working-time-bar"
              style={{
                backgroundColor: authorizedUser
                  ? authorizedUser.userColor ?? ""
                  : "",
              }}
            >
              <div className="working-time-bar__user">
                {activity.userSymbols || localUserSymbols}
              </div>
              <div className="working-time-bar__time">
                {(activity?.countingTime ||
                  (localTimeManagement && localTimeManagement.countingTime)) &&
                liveCountedTime
                  ? convertTime(liveCountedTime)
                  : isManyActivity
                  ? convertTime(activeTime?.allTime)
                  : activity.allTime && convertTime(activity.allTime)}
              </div>
              {(activity?.countingTime ||
                (localTimeManagement && localTimeManagement.countingTime)) && (
                <SVG
                  className="working-time-bar__clock"
                  type={SVG_TYPE.CLOCK}
                />
              )}
            </div>
          )}
          {mergedTimeManagement() &&
            mergedTimeManagement().map((item: any, index: number) => {
              const firstElement = index === 0;
              return (
                <div
                  className={`single-timing ${
                    firstElement ? "single-timing--first" : ""
                  } ${item.comment ? "single-timing--comment" : ""}`}
                >
                  <div className="working-time-bar__user single-timing--user">
                    {item.userSymbols}
                  </div>
                  <div className="working-time-bar__time">
                    {convertTime(item.countedTime)}
                  </div>
                  <div className="single-timing__form">
                    <div className="single-timing-form">
                      <Formik
                        initialValues={{
                          type: "",
                          comment: item.comment,
                        }}
                        enableReinitialize
                        onSubmit={async (values: any) => console.log(values)}
                      >
                        {({ handleSubmit }) => {
                          return (
                            <form
                              className={`working-time-form`}
                              onSubmit={handleSubmit}
                            >
                              <Field
                                name="comment"
                                maxLength={255}
                                placeholder={
                                  isMobile()
                                    ? "Dodaj komentarz"
                                    : "Kliknij, aby dodać komentarz"
                                }
                                ref={inputRef}
                                component={Input}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleWriteComment(e, item.uuid);
                                }}
                                onKeyDown={(e: any) => {
                                  handleCommentKeyDown(e);
                                }}
                              />
                            </form>
                          );
                        }}
                      </Formik>
                    </div>
                    <div className="single-timing__date">
                      {formatDateTime(item.dateStart)}
                    </div>
                  </div>
                  {!isOffline && (
                    <div className="working-time-item__menu single-timing--menu">
                      <ContextMenu
                        className="dtb__user-submenu"
                        items={workingTimeMenu(label, item.uuid, item)}
                      >
                        <SVG type={SVG_TYPE.ELLIPSIS} />
                      </ContextMenu>
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default WorkingTime;
